import { createAction } from '@reduxjs/toolkit';

export const setRateLimitLastRequestTime = createAction<number | undefined>('set/rate-limit-last-request-time');
export const setCommentLikeRateLimitLastRequestTime = createAction<number | undefined>(
    'set/comment-like-rate-limit-last-request-time',
);
export const setLastConnectionErrorTime = createAction<number | undefined>(
    'set/internet-connection-error-rate-limit-last-request-time',
);
